module.exports = __webpack_public_path__ + "img/stickers_0002_star.5f8fd48a.png";